import React from "react";
import { Redirect, useParams } from "react-router-dom";

import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";
import {
  ProcManagementCreateService,
  ContextProps,
} from "../../../../application/service/service-provider/proc-management/create";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { Content } from "../../../organisms/proc-management/form";
import { FeatureEnabledOrgOnly } from "../../../organisms/proc-management/util";
import { isProcedure } from "../../../../application/domain/proc-management";
import { useAuthContextV2 } from "../../../../auth-state";

const ProcManagementCreate: React.FC<ContextProps> = ({
  procedure,
  smartApply,
  onSave,
  onChange,
  onFileAttached,
  isUpdating,
  getFileUploading,
  publish,
  unPublish,
  archive,
  copy,
  publishProcAndSmartApply,
  setOrganization,
  canEditGroupId,
  attachGroupToProc,
  setAuthCtx,
  canManipulateProc,
  shouldDisplayError,
  validationErrors,
  smartApplyValidationResult,
  organizationSlug,
}) => {
  const { orgId } = useParams<{
    orgId: string;
  }>();
  const breadcrumbs = [
    { to: ServiceProviderR.Home.link({}), title: "テナント一覧" },
    {
      to: ServiceProviderR.ProcManagementProcsList.link({ orgId }),
      title: "手続きマスタ",
    },
    {
      to: ServiceProviderR.ProcManagementCreate.link({ orgId }),
      title: "新規作成",
    },
  ];

  React.useEffect(() => {
    setOrganization(orgId);
  }, [orgId, setOrganization]);

  const { auth } = useAuthContextV2();
  React.useEffect(() => {
    setAuthCtx(auth.data);
  }, [setAuthCtx, auth]);

  if (isProcedure(procedure)) {
    return (
      <Redirect
        to={ServiceProviderR.ProcManagementDetail.link({
          orgId,
          procId: procedure.id,
        })}
      />
    );
  }

  return (
    <FeatureEnabledOrgOnly>
      <ServiceProviderTemplate breadcrumbs={breadcrumbs}>
        <Content
          organizationSlug={organizationSlug}
          procedure={procedure}
          smartApply={smartApply}
          onPressSave={onSave}
          onChange={onChange}
          onFileAttached={onFileAttached}
          isUpdating={isUpdating}
          getFileUploading={getFileUploading}
          publish={publish}
          unPublish={unPublish}
          archive={archive}
          copy={copy}
          publishProcAndSmartApply={publishProcAndSmartApply}
          isServiceProviderAccount
          canEditGroupId={canEditGroupId()}
          onAddGroup={attachGroupToProc}
          disabled={!canManipulateProc()}
          shouldDisplayError={shouldDisplayError}
          validationErrors={validationErrors}
          smartApplyValidationResult={smartApplyValidationResult}
        />
      </ServiceProviderTemplate>
    </FeatureEnabledOrgOnly>
  );
};

export const ProcManagementCreateContainer = connectPageService(
  ProcManagementCreate,
  () => new ProcManagementCreateService(),
);
